import React from "react";
import { createUseStyles } from "react-jss";
import { inject } from "mobx-react";
import PropTypes from "prop-types";

const useStyles = createUseStyles({
	root: {
		fontFamily: "Inter-Regular",
		color: "#6D7482",
		fontSize: "12px",
		lineHeight: "16px",
	},
	plus: {
		marginRight: "2px",
	},
});

const TextItem = (props) => {
	const {
		ApplicationModel: { text },
		description,
	} = props;
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<span className={classes.plus}>{text.plus}</span>
			{description}
		</div>
	);
};

TextItem.propTypes = {
	text: PropTypes.string,
	description: PropTypes.string,
};
export default inject("ApplicationModel")(TextItem);
